import React from 'react';
import { IconDotsHorizontal } from '../../../base/icons/svg';
import Button from '../../../base/ui/components/web/Button';
const ParticipantActionEllipsis = ({ accessibilityLabel, onClick, className, participantID }) => {
    return (React.createElement(Button, { accessibilityLabel: accessibilityLabel, icon: IconDotsHorizontal, className: `${className} participant-action-ellipsis-breakoutroom participantpane-item-icons`, onClick: onClick, size: 'small', testId: participantID ? `participant-more-options-${participantID}` : undefined }));
};
export default ParticipantActionEllipsis;
